import { render, staticRenderFns } from "./DashboardV2Layout.vue?vue&type=template&id=13c471fd"
import script from "./DashboardV2Layout.vue?vue&type=script&lang=js"
export * from "./DashboardV2Layout.vue?vue&type=script&lang=js"
import style0 from "./DashboardV2Layout.vue?vue&type=style&index=0&id=13c471fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports